// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3vvMx","productName":"Table_productName__3l_CD"};